import { render } from "./FormRadio.vue?vue&type=template&id=f5d38b34&scoped=true"
import script from "./FormRadio.vue?vue&type=script&lang=js"
export * from "./FormRadio.vue?vue&type=script&lang=js"

import "./FormRadio.vue?vue&type=style&index=0&id=f5d38b34&scoped=true&lang=css"

import exportComponent from "/builds/aquis/vue-modules/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d38b34"]])

export default __exports__